"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Grid } from '../Grid/Grid.web.js';
import { Box } from '../Box/Box.web.js';
import { spacing } from '../constants/spacing.js';

var _excluded = ["children"];
var Section = function Section(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    tag: "section",
    "data-testid": "elemental-Section",
    pt: spacing.l,
    pb: spacing.l
  }, props), /*#__PURE__*/React.createElement(Grid, null, children));
};

export { Section };
